import React from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import './Mindset.scss';
import mindset from "../../../../Assets/Images/Mindset-image.png"

export default function Mindset({ apiData, reportType, pageNumber }) {
  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview apiData={apiData} />
      <div className="mindset-container">
        <div className="mindset-content">
          <div className="mindset-header">
            <h4>MINDSET</h4>
            <h2>The Hidden Driver of Leadership Growth</h2>
          </div>
          <p><b>The biggest barrier to leadership growth? Your mindset.</b></p>
          <p>
            Skills can be taught. Strategies can be learned. But if your mindset is stuck, so is your leadership.
          </p>
          <p>
            The Quadrant Flow™ Assessment includes a mindset component, with resources provided by Healthy Growing Leaders. Drawing on the research of Stanford psychologist Dr. Carol Dweck, this framework helps you identify whether you approach leadership with a fixed or growth mindset and how you respond to challenge, feedback, failure, and change.
          </p>
          <p>
            Here’s the truth. Most leaders carry a mix. You may be open in one area and shut down in another, especially when pressure, ego, or expectations are in play. This is why the Quadrant Flow™ Mindset Profile outlines five stages of mindset development, helping you name where you are and map a path forward.
          </p>
          <p>
            And here’s where it gets powerful. When you combine leadership flow with a growth mindset, your development compounds. You stop leading from just what’s comfortable and start growing into what’s possible. The best leaders aren’t the ones who know it all. They’re the ones who stay open to growth. Always.
          </p>

        </div>
      <div style={{display:"flex", justifyContent:"center"}}>
          <img src={mindset} alt='' width={374} height={280} />
      </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  )
}
